export default __webpack_public_path__ + "static/media/archi_view3_f.5169bf92.webp";